export default "__VITE_ASSET__Bcq68Rg8__"